import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ParticlesModule } from 'angular-particle/';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VisitorRoutingModule } from './visitor-routing.module';

import { HomeScreenComponent } from './shared/screens/home-screen/home-screen.component';
import { MobileHomeScreenComponent } from './mobile/screens/mobile-home-screen/mobile-home-screen.component';


import { SharedFooterComponent } from './shared/components/shared-footer/shared-footer.component';
import { SharedCardServiceComponent } from './shared/components/shared-card-service/shared-card-service.component';

import { DesktopHomeScreenComponent } from './desktop/screens/desktop-home-screen/desktop-home-screen.component';
import { DesktopNavbarComponent } from './desktop/components/desktop-navbar/desktop-navbar.component';

import { DesktopServicesComponent } from './desktop/components/desktop-services/desktop-services.component';
import { DesktopHeaderComponent } from './desktop/components/desktop-header/desktop-header.component';
import { DesktopProjectsComponent } from './desktop/components/desktop-projects/desktop-projects.component';
import { DesktopContactComponent } from './desktop/components/desktop-contact/desktop-contact.component';
import { DesktopClientsComponent } from './desktop/components/desktop-clients/desktop-clients.component';

import { MobileNavbarComponent } from './mobile/components/mobile-navbar/mobile-navbar.component';
import { MobileHeaderComponent } from './mobile/components/mobile-header/mobile-header.component';
import { MobileServicesComponent } from './mobile/components/mobile-services/mobile-services.component';
import { MobileProjectsComponent } from './mobile/components/mobile-projects/mobile-projects.component';
import { MobileContactComponent } from './mobile/components/mobile-contact/mobile-contact.component';
import { MobileClientsComponent } from './mobile/components/mobile-clients/mobile-clients.component';

// tslint:disable-next-line: typedef
export function playerFactory() {
  return player;
}

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

const sharedScreens = [
  HomeScreenComponent
];

const desktopScreens = [
  DesktopHomeScreenComponent
];

const mobileScreens = [
  MobileHomeScreenComponent
];

const sharedComponents = [
  SharedFooterComponent,
  SharedCardServiceComponent
];

const desktopComponents = [
  DesktopNavbarComponent,
  DesktopHeaderComponent,
  DesktopServicesComponent,
  DesktopProjectsComponent,
  DesktopClientsComponent,
  DesktopContactComponent,
];

const mobileComponents = [
  MobileNavbarComponent,
  MobileHeaderComponent,
  MobileServicesComponent,
  MobileProjectsComponent,
  MobileClientsComponent,
  MobileContactComponent,
];

@NgModule({
  declarations: [
    ...sharedScreens,
    ...desktopScreens,
    ...mobileScreens,
    ...sharedComponents,
    ...desktopComponents,
    ...mobileComponents,
    
  ],
  imports: [
    CommonModule,
    VisitorRoutingModule,
    SwiperModule,
    LottieModule.forRoot({ player: playerFactory }),
    ParticlesModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})
export class VisitorModule { }
